<template>
    <div class="btn-group page-nav " role="group" aria-label="nav">
        <router-link class="btn" :to="{name: 'vehicules'}" :class="{ 'active': this.$route.name === 'vehicules'}">
            <i class="fa-solid fa-truck-moving"></i> Vehicules
        </router-link>
        <router-link class="btn" :to="{name: 'interventions'}" :class="{ 'active': this.$route.name === 'interventions'}">
            <i class="fa-solid fa-screwdriver-wrench"></i> Interventions
        </router-link>
    </div>
</template>